import {RangeModel} from '../shared/range.model';
import {Enums} from '../../extensions/enums';
import {QuestionExtendedModel} from '../question-extended.model';

export class SingleAdditionModel extends QuestionExtendedModel {

  model: {
    firstRange: RangeModel,
    secondRange: RangeModel,
    possibleAnswers: RangeModel,
    minOutcome: number,
    maxOutcome: number,
    numAnswers: number,
    imageTypeOne: string,
    gridWidth: number;
  } = {
    firstRange: new RangeModel(),
    secondRange: new RangeModel(),
    possibleAnswers: new RangeModel(),
    minOutcome: null,
    maxOutcome: null,
    numAnswers: 4,
    gridWidth: 0,
    imageTypeOne: Enums.QuestionImages.Apple
  };

  static generateModel(json: any): SingleAdditionModel {

    const q = new SingleAdditionModel();

    const model = json.model;
    if (model) {

      if (model.firstRange) {
        q.model.firstRange = RangeModel.generateModel(model.firstRange);
      }

      if (model.secondRange) {
        q.model.secondRange = RangeModel.generateModel(model.secondRange);
      }

      if (model.possibleAnswers) {
        q.model.possibleAnswers = RangeModel.generateModel(model.possibleAnswers);
      }

      q.model.minOutcome = model.minOutcome;
      q.model.maxOutcome = model.maxOutcome;

      q.model.numAnswers = model.numAnswers;
      q.model.imageTypeOne = model.imageTypeOne;
      q.model.gridWidth = model.gridWidth;

    }

    return q;

  }

}
